import { useDesignerStore } from '../../stores';
import { t } from '../../i18n';
import styles from './ZoomControls.module.css';

const MIN_ZOOM = 0.25;
const MAX_ZOOM = 2;
const ZOOM_STEP = 0.1;

export const ZoomControls = () => {
  const { zoom, setZoom } = useDesignerStore();

  const handleZoomIn = () => {
    const newZoom = Math.min(MAX_ZOOM, zoom + ZOOM_STEP);
    setZoom(Math.round(newZoom * 100) / 100);
  };

  const handleZoomOut = () => {
    const newZoom = Math.max(MIN_ZOOM, zoom - ZOOM_STEP);
    setZoom(Math.round(newZoom * 100) / 100);
  };

  const handleFitToScreen = () => {
    setZoom(1.0);
  };

  const zoomPercent = Math.round(zoom * 100);

  return (
    <div className={styles.zoomControls}>
      <button
        className={styles.zoomButton}
        onClick={handleZoomOut}
        disabled={zoom <= MIN_ZOOM}
        title={t('design.zoom.out', 'Zoom Out')}
      >
        −
      </button>
      <span className={styles.zoomLevel}>{zoomPercent}%</span>
      <button
        className={styles.zoomButton}
        onClick={handleZoomIn}
        disabled={zoom >= MAX_ZOOM}
        title={t('design.zoom.in', 'Zoom In')}
      >
        +
      </button>
      <button
        className={styles.zoomButton}
        onClick={handleFitToScreen}
        title={t('design.zoom.fit', 'Fit to Screen')}
      >
        {t('design.zoom.fit_label', 'Fit')}
      </button>
    </div>
  );
};

export default ZoomControls;
